import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Approach } from './components/Approach';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <About data-id="element-3" />
      <Services data-id="element-4" />
      <Approach data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Contact data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}